// Second step of sign-in for accounts with two-step verification (admins):
// the 6-digit code from the authenticator app. Shown by LoginScreen when
// Firebase answers auth/multi-factor-auth-required.
import React, { useState } from 'react';
import { getMultiFactorResolver, TotpMultiFactorGenerator } from 'firebase/auth';
import { auth } from '../firebase';

export const needsSecondFactor = (error) => error?.code === 'auth/multi-factor-auth-required';

export default function MfaCodePrompt({ error, onCancel }) {
    const [code, setCode] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setMessage(null);
        setBusy(true);
        try {
            const resolver = getMultiFactorResolver(auth, error);
            const hint = resolver.hints.find((h) => h.factorId === TotpMultiFactorGenerator.FACTOR_ID);
            if (!hint) throw new Error('no-totp');
            await resolver.resolveSignIn(TotpMultiFactorGenerator.assertionForSignIn(hint.uid, code.trim()));
            // Signed in: useAuth takes over.
        } catch (err) {
            setMessage(err?.code === 'auth/invalid-verification-code'
                ? 'Código incorreto. Confira o app autenticador e tente de novo.'
                : err?.code === 'auth/code-expired' || err?.code === 'auth/multi-factor-auth-required'
                    ? 'O tempo para digitar o código acabou. Entre de novo.'
                    : 'Não foi possível confirmar o código. Tente de novo.');
            setBusy(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-4">
            <form onSubmit={submit} className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-sm space-y-4">
                <h2 className="text-xl font-bold text-gray-900">Verificação em duas etapas</h2>
                <p className="text-gray-700">Digite o código de 6 dígitos do seu app autenticador.</p>
                <input
                    value={code}
                    onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    autoFocus
                    aria-label="Código de verificação"
                    placeholder="000000"
                    className="w-full text-center text-2xl tracking-widest border border-gray-400 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-600"
                />
                {message && <p role="alert" className="text-red-700 text-sm">{message}</p>}
                <button type="submit" disabled={busy || code.length !== 6}
                    className="w-full bg-green-600 text-white font-bold py-3 rounded-lg hover:bg-green-700 disabled:opacity-50">
                    {busy ? 'Verificando…' : 'Confirmar'}
                </button>
                <button type="button" onClick={onCancel} className="w-full text-gray-600 underline text-sm">Cancelar</button>
            </form>
        </div>
    );
}
